import env from 'env/env';

import historyUtils from 'utils/history';
import { isEmbeddedInWebView } from 'utils/webview';

export const appendClientIdParamWhenInWebview = (url: string) => {
  const clientIdParamName = 'client_id';

  if (!url) {
    return '';
  }

  if (!isEmbeddedInWebView()) {
    return url;
  }

  const clientId = new URLSearchParams(historyUtils.getLocation().search).get(clientIdParamName);

  if (!clientId) {
    return url;
  }

  try {
    const gotoUrl = new URL(url, env.clientHost);
    gotoUrl.searchParams.set(clientIdParamName, clientId);

    return `${gotoUrl.pathname}${gotoUrl.search}`;
  } catch {
    return '';
  }
};
